var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75ZM8.99414 12.75C9.11157 14.974 9.75009 17.1726 10.9131 19.1143L11.0156 19.2627C11.5631 19.9584 12.6107 19.909 13.0869 19.1143L13.3223 18.7051C14.3367 16.8663 14.8966 14.8193 15.0059 12.75H8.99414ZM4.28711 12.75C4.5744 15.7413 6.56149 18.2341 9.27148 19.2539C8.19296 17.2355 7.5998 15.0039 7.49219 12.75H4.28711ZM16.5078 12.75C16.4002 15.0041 15.8062 17.2354 14.7275 19.2539C17.438 18.2343 19.4256 15.7416 19.7129 12.75H16.5078ZM14.7275 4.74512C15.8065 6.76379 16.4001 8.99563 16.5078 11.25H19.7129C19.4256 8.25831 17.4381 5.76468 14.7275 4.74512ZM13.0869 4.88574C12.5778 4.0378 11.4205 4.03918 10.9131 4.88672L10.6777 5.29492C9.66326 7.13367 9.10344 9.18073 8.99414 11.25H15.0059C14.8884 9.02614 14.2499 6.82831 13.0869 4.88672V4.88574ZM9.27148 4.74512C6.56132 5.76489 4.57441 8.25863 4.28711 11.25H7.49219C7.59985 8.99581 8.19267 6.76366 9.27148 4.74512Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorld);
export default __webpack_public_path__ + "static/media/icon-world.088972f7d82fa48d13c068a90b97bcba.svg";
export { ForwardRef as ReactComponent };